<template>
  <div class="role">
    <div class="role-wrap" v-if="!isEdit">
      <div class="qjc-flex query-wrap">
        <el-input class="search-input" v-model="nowMobile" @input="accountInput" :placeholder="$t('table.t43')">
          <div class="search-icon" slot="prefix">
            <i class="el-icon-search"></i>
          </div>
        </el-input>
        <el-button @click="query" :loading="submiting" class="query-btn qjc-fts-16">{{ $t('table.t39') }}</el-button>
        <el-button @click="handleRet" class="query-btn qjc-fts-16">{{ $t('table.t40') }}</el-button>
      </div>
      <el-table :data="user" class="list">

        <template slot="empty">
          <div class="empty-wrap">
            <el-image class="empty-img" :src="require('@/assets/images/empty-history.png')"></el-image>
            <div class="empty-text">暂无数据</div>
          </div>
        </template>
        <el-table-column prop="id" min-width="80px" :label="$t('table.t1')" class-name="id">

        </el-table-column>
        <el-table-column prop="mobile" :label="$t('table.t2')" class-name="mobile" min-width="180px">
          <template slot-scope="scope">
            {{ scope.row.mobile ? scope.row.mobile : '--' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('table.t3')" class-name="goods_name" prop="goods_name" min-width="140px">

        </el-table-column>

        <el-table-column prop="sex" :label="$t('table.t4')" class-name="sex" min-width="60">
          <template slot-scope="scope">
            {{ scope.row.sex == '1' ? $t('open.t14') : scope.row.sex == '2' ? $t('open.t15') : '' }}
          </template>
        </el-table-column>

        <el-table-column prop="birth" :label="$t('table.t5')" class-name="birth" min-width="120px">
        </el-table-column>
        <el-table-column prop="examdate" :label="$t('table.t6')" class-name="examdate" min-width="120px">
          <template slot-scope="scope">
            {{ scope.row.examdate ? scope.row.examdate : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="is_finish" :label="$t('table.t7')" class-name="is_finish" min-width="80px">
          <template slot-scope="scope">
            <div class="order_status_1" v-if="scope.row.is_finish == 1">
              未体检
            </div>
            <div class="order_status_80" v-if="scope.row.is_finish == 80">
              {{ $t('table.t36') }}
            </div>

          </template>
        </el-table-column>

        <el-table-column prop="created_at" :label="$t('table.t15')" min-width="160px" />
        <el-table-column prop="action" :label="$t('table.t9')" class-name="sex" min-width="120px" fixed="right">
          <template slot-scope="scope">
            <div class="action-btn" v-if="scope.row.is_finish == 1 && scope.row.package != '3'"
              @click="handleUpdateBo(scope.row)">
              录入
            </div>
            <div class="action-btn" v-if="(showUpdateBtn(scope.row) && scope.row.is_finish == 80)"
              @click="handleUpdate(scope.row)">
              {{ $t('table.t38') }}
            </div>

          </template>
        </el-table-column>



      </el-table>

      <!-- 分页 -->
      <el-pagination prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper" hide-on-single-page
        :current-page.sync="pager.page" :page-count="pager.pagecount" :page-size="pager.pagesize" :total="pager.count"
        @current-change="pageChange">
      </el-pagination>
    </div>

    <div class="open-wrap" v-if="isEdit">
      <new-question v-if="!isMuying" :isBo="isBo" :dataId="id" type="update" :cancelEdit="cancelDate"></new-question>
      <new-Insert-My v-else :dataId="id" type="update" :clearData="clearData"></new-Insert-My>
    </div>
  </div>
</template>

<script>
import { adminRole, printBatchQuery, mainDataQuery } from "@/utils/axios"
import NewInsert from '@/components/NewInsert'
import NewInsertMy from '@/components/NewInsert/muying'
import NewQuestion from '@/components/NewQuestion'


export default {
  name: 'adminDataUpdate',
  components: {
    NewInsert,
    NewInsertMy,
    NewQuestion
  },
  data () {
    return {
      isEdit: false,
      isMuying: false,
      id: '',
      mainHeight: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 60,
      formData: {
        mobile: '',
        yyuserid: '',
        sex: '',
        birth: '',
        examdate: '',
        examplace: '',
        package: '',

        height: '',
        weight: '',
        bust: '',
        waist: '',
        hip: '',
        fat: '',

        area: '',
        marry: '',
        childcnt: '',
        drink: '',
        smoke: '',
        habeat: '',
        vege: '',
        habsport: '',
        sleep: '',
        disease: [
          { "kdis": "K01", "level": "0" },
          { "kdis": "K02", "level": "0" },
          { "kdis": "K03", "level": "0" },
          { "kdis": "K04", "level": "0" },
          { "kdis": "K05", "level": "0" },
          { "kdis": "K06", "level": "0" },
          { "kdis": "K07", "level": "0" },
          { "kdis": "K08", "level": "0" },
          { "kdis": "K09", "level": "0" },
          { "kdis": "K10", "level": "0" },
          { "kdis": "K11", "level": "0" },
          { "kdis": "K12", "level": "0" },
          { "kdis": "K13", "level": "0" },
          { "kdis": "K14", "level": "0" },
          { "kdis": "K15", "level": "0" },
          { "kdis": "K16", "level": "0" },
          { "kdis": "K17", "level": "0" },
          { "kdis": "K18", "level": "0" },
          { "kdis": "K19", "level": "0" }
        ],
        oper: [],
        famdis: [],

        examine: [
          { "ne": "WBC", "ve": "", "ut": "A" },
          { "ne": "HGB", "ve": "", "ut": "A" },
          { "ne": "PLT", "ve": "", "ut": "A" },
          { "ne": "FG", "ve": "", "ut": "B" },
          { "ne": "HBA1C", "ve": "", "ut": "A" },
          { "ne": "CHOL", "ve": "", "ut": "B" },
          { "ne": "LDLC", "ve": "", "ut": "B" },
          { "ne": "HDLC", "ve": "", "ut": "B" },
          { "ne": "TG", "ve": "", "ut": "B" },
          { "ne": "GOT", "ve": "", "ut": "A" },
          { "ne": "GPT", "ve": "", "ut": "A" },
          { "ne": "ALP", "ve": "", "ut": "A" },
          { "ne": "ALB", "ve": "", "ut": "B" },
          { "ne": "CRE", "ve": "", "ut": "B" },
          { "ne": "UA", "ve": "", "ut": "B" },
          { "ne": "EGFR", "ve": "", "ut": "A" }
        ],

        operator: ''// 当前后台操作人手机号
      },
      rules: {
        name: [
          { required: true, message: '角色名称不能为空', trigger: 'blur' }
        ],
        power: [
          { required: true, message: '请至少选择一项', trigger: 'change' }
        ]
      },
      user: [],// 客户信息

      submiting: false,//正在请求

      pager: {
        count: 0,
        page: 1,// 默认第一页
        pagecount: 0,
        pagesize: 12//默认一页12条数据
      },

      nowMobile: '',// 存储当前已查询企业用户id或手机号
      isBo: false,
    }
  },
  inject: ['handleRefresh'],
  mounted () {
    this.getList()
  },
  watch: {

  },
  methods: {
    accountInput (val) {
      let codeReg = new RegExp("[A-Za-z0-9]+");
      let len = val.length;
      let str = '';
      for (let i = 0; i < len; i++) {
        if (codeReg.test(val[i])) {
          str += val[i]
        }
      }
      this.nowMobile = str
      // this.getList();
    },
    cancelDate () {
      this.isEdit = false;
      this.getList()

    },
    clearData () {
      this.formData = {
        mobile: '',
        yyuserid: '',
        sex: '',
        birth: '',
        examdate: '',
        examplace: '',
        package: '',

        height: '',
        weight: '',
        bust: '',
        waist: '',
        hip: '',
        fat: '',

        area: '',
        marry: '',
        childcnt: '',
        drink: '',
        smoke: '',
        habeat: '',
        vege: '',
        habsport: '',
        sleep: '',
        disease: [
          { "kdis": "K01", "level": "0" },
          { "kdis": "K02", "level": "0" },
          { "kdis": "K03", "level": "0" },
          { "kdis": "K04", "level": "0" },
          { "kdis": "K05", "level": "0" },
          { "kdis": "K06", "level": "0" },
          { "kdis": "K07", "level": "0" },
          { "kdis": "K08", "level": "0" },
          { "kdis": "K09", "level": "0" },
          { "kdis": "K10", "level": "0" },
          { "kdis": "K11", "level": "0" },
          { "kdis": "K12", "level": "0" },
          { "kdis": "K13", "level": "0" }
        ],
        oper: [],
        famdis: [],

        examine: [
          { "ne": "WBC", "ve": "", "ut": "A" },
          { "ne": "HGB", "ve": "", "ut": "A" },
          { "ne": "PLT", "ve": "", "ut": "A" },
          { "ne": "FG", "ve": "", "ut": "B" },
          { "ne": "HBA1C", "ve": "", "ut": "A" },
          { "ne": "CHOL", "ve": "", "ut": "B" },
          { "ne": "LDLC", "ve": "", "ut": "B" },
          { "ne": "HDLC", "ve": "", "ut": "B" },
          { "ne": "TG", "ve": "", "ut": "B" },
          { "ne": "GOT", "ve": "", "ut": "A" },
          { "ne": "GPT", "ve": "", "ut": "A" },
          { "ne": "ALP", "ve": "", "ut": "A" },
          { "ne": "ALB", "ve": "", "ut": "B" },
          { "ne": "CRE", "ve": "", "ut": "B" },
          { "ne": "UA", "ve": "", "ut": "B" },
          { "ne": "EGFR", "ve": "", "ut": "A" }
        ],

        operator: '',// 当前后台操作人手机号
      }
    },

    query () {
      // 正在请求
      if (this.nowMobile.trim() != '') {
        this.submiting == true;
        this.pager.page = 1;
        this.getList();
      }
    },
    handleRet () {
      this.nowMobile = '';
      this.pager.page = 1;
      this.getList();
    },
    pageChange (page) {
      this.pager.page = page;
      this.getList();
    },

    getList () {
      mainDataQuery({
        act: 'data-update',
        mobile: this.nowMobile,
        page: this.pager.page,
        pagesize: this.pager.pagesize
      }).then(res => {
        if (res.code == 200) {
          this.submiting == false;
          const result = JSON.parse(window.atob(res.data))
          if (result.data.length == 0) {
            this.user = [];
            this.pager = {
              count: 0,
              page: 1,// 默认第一页
              pagecount: 0,
              pagesize: 12//默认一页12条数据
            }

          } else {
            this.user = result.data;
            //分页
            this.pager = result.pager;

            // 数值可能为字符串，需转换为number
            for (var key in this.pager) {
              this.pager[key] = parseInt(this.pager[key]);
            }
          }
        } else {
          this.submiting == false;
          this.$myAlert({
            type: 'fail',
            content: res.msg,
          });
        }
      });
    },
    hanleLoadAll () {
      this.nowMobile = '',
        this.getList();
    },
    handleUpdateBo (row) {
      this.id = row.id
      this.isBo = true
      this.isEdit = true;
    },

    handleUpdate (row) {
      // 数据修改
      this.id = row.id
      this.isBo = false
      if (row.package == '3') {
        this.isMuying = true
      } else {
        this.isMuying = false
      }
      this.isEdit = true;
    },

    showUpdateBtn ({ type }) {
      return type == "AIBG" || type == "M22" || type == "AIZH" || type == "AIFB" || type == "AIMB"
    }

  }
}
</script>

<style scoped>
.query-wrap>>>.el-input__inner {
  height: 36px;
  line-height: 36px;
}

.role>>>.el-table--fit {
  border-bottom: 1px solid #eeeeee !important;
}

.role>>>.el-table__fixed-right::before,
.el-table__fixed::before {
  height: 0 !important;
}
</style>
<style lang="scss" scoped>
.role {
  position: relative;
  padding: 24px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  border: 12px solid #F2F4FA;

  .role-wrap {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .query-btn {
    width: 72px;
    height: 36px;
    line-height: 36px;
    font-size: 15px;
    padding: 0;
    margin-left: 16px;
    border: none;
    color: #fff;
  }

  .list {
    margin-top: 16px;

    &::before {
      display: none;
    }

    .el-button {
      font-size: 14px;
      padding: 6px 8px;
      font-weight: 400;

      +.el-button {
        margin-left: 24px;
      }
    }

    .package-cell {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .action-btn {
    font-size: 14px;
    // font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 400;
    color: #6883FB;
    cursor: pointer;
    display: inline-block;

    &:hover {
      color: #7a92fb;
    }
  }

  .action-btn-end {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #B4BBCC;
    cursor: pointer;
  }

  .foot-pagination {
    // position: absolute;
    // bottom: 0;
    width: 100%;
    padding-bottom: 20px;
    // height: 80px;
  }

  .pagination {
    // position: absolute;
    // bottom: 0;
    width: 100%;
    margin-top: 24px;
    text-align: center;
  }

  .search-input {
    // width: 458px;
    width: 226px;
    height: 34px;
  }

  .search-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 36px;
  }

  .el-dialog {

    .dialog-title {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #293033;
      text-align: center;
    }

    .all-power {
      -webkit-appearance: none;
      background-color: #FFF;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #DCDFE6;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      height: 40px;
      line-height: 40px;
      outline: 0;
      padding: 0 15px;
      transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
      width: 100%;
    }

    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: center;

      .cancel-btn {
        width: 94px;
        height: 34px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #6883FB;
        border: 1px solid #6883FB;
        border-radius: 17px;
        background-color: #fff;
      }

      .submit-btn {
        width: 94px;
        height: 34px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #fff;
        border: none;
        border-radius: 17px;
        background-color: #6883FB;
        margin-left: 16px;
      }

      .el-button {
        padding: 9px 15px;
      }
    }
  }
}

.finish-not {
  position: relative;
  padding-left: 12px;

  &::before {
    content: '';
    position: absolute;
    top: 8px;
    left: 0;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #FF5219;
  }
}

.finished {
  position: relative;
  padding-left: 12px;

  &::before {
    content: '';
    position: absolute;
    top: 8px;
    left: 0;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #38E019;
  }
}

.empty-wrap {
  padding: 100px 0;
}

.empty-img {
  width: 338px;
  height: 218px;
}
</style>
